import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '../../common/Button';

interface Props {
  count: number;
  onDone: () => void;
}

export const ResultStep: React.FC<Props> = ({ count, onDone }) => (
  <div className="flex flex-col items-center gap-4 py-10 text-center">
    <CheckCircle2 className="h-12 w-12 text-green-500" />
    <p className="text-base font-semibold text-gray-900" data-test-id="import-rb-result-message">
      {count} roasted bulk item{count === 1 ? '' : 's'} imported.
    </p>
    <p className="text-sm text-gray-500 max-w-md">
      The new stock is now available in the Finished Goods production picker,
      merged with any existing roasted bulk for the same green bean and roast type.
    </p>
    <Button variant="primary" onClick={onDone} data-test-id="import-rb-result-done">
      Done
    </Button>
  </div>
);
